import type { BattleData } from '../../components/BattleCard';
import { useLobbyItems } from '../../components/caseBattle/useLobbyItems';
import { useShowClock } from '../../components/caseBattle/lobbyOrder';
import {
  DEFAULT_LOBBY_FILTERS,
  useCaseBattleHistoryAllInfinite,
  useCaseBattleHistoryMineInfinite,
  useLobbyCaseBattles,
} from '../../queries/useCaseBattleQueries';

export type BattleFilter = 'active' | 'historyAll' | 'historyMine';

const NO_MORE_PAGES = () => undefined;

export interface BattleTab {
  items: BattleData[] | undefined;
  now: number;
  filteredOut: boolean;
  isLoading: boolean;
  error: unknown;
  refetch: () => unknown;
  hasMore: boolean;
  isFetchingMore: boolean;
  fetchNextPage: () => unknown;
}

export const useBattleTab = (filter: BattleFilter): BattleTab => {
  const lobby = useLobbyCaseBattles(DEFAULT_LOBBY_FILTERS, filter === 'active');
  const historyAll = useCaseBattleHistoryAllInfinite(filter === 'historyAll');
  const historyMine = useCaseBattleHistoryMineInfinite(filter === 'historyMine');
  const now = useShowClock(lobby.data?.items);
  const { items: lobbyItems, filteredOut } = useLobbyItems(lobby.data?.items, now);

  if (filter === 'active') {
    return {
      items: lobbyItems,
      now,
      filteredOut,
      isLoading: lobby.isLoading,
      error: lobby.error,
      refetch: lobby.refetch,
      hasMore: false,
      isFetchingMore: false,
      fetchNextPage: NO_MORE_PAGES,
    };
  }
  const history = filter === 'historyAll' ? historyAll : historyMine;
  return {
    items: history.data,
    now,
    filteredOut: false,
    isLoading: history.isLoading,
    error: history.error,
    refetch: history.refetch,
    hasMore: history.hasNextPage,
    isFetchingMore: history.isFetchingNextPage,
    fetchNextPage: history.fetchNextPage,
  };
};
